import { gql } from "@apollo/client";

export const REJECT_INVOICE_UPLOAD_UNIT = gql`
  mutation rejectInvoiceUploadUnit($input: RejectUploadUnitInput!) {
    documentHandler {
      rejectInvoiceUploadUnit(input: $input) {
        success
      }
    }
  }
`;
